import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { SendCrewInvite } from '@/modules/auth/use-cases'

type CrewInviteBody = {
  orgId: string
  orgType: 'crew'
  role: 'manager'
  email: string
  firstName: string
  lastName: string
}

export class EdgeSendCrewInviteRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: SendCrewInvite = async (params) => {
    const body: CrewInviteBody = {
      orgId: params.orgId,
      orgType: 'crew',
      role: 'manager',
      email: params.email,
      firstName: params.firstName,
      lastName: params.lastName,
    }
    const request: HttpRequest<CrewInviteBody> = { url: '/invitations', body }
    try {
      await this.httpClient.post<CrewInviteBody, unknown>(request)
    } catch (error) {
      mapServerError(error)
    }
  }
}
